// extracted by mini-css-extract-plugin
module.exports = {"finalScene":"FinalScene_finalScene__2BN2J","greenText":"FinalScene_greenText__1Nzkn","subtitle":"FinalScene_subtitle__3-3sT","annotation":"FinalScene_annotation__304KU"};